import {
  Alert,
  Box,
  Button,
  Divider,
  Grid,
  Grid2,
  IconButton,
  Paper,
  Snackbar,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import BackButton from "../../components/AppButtons/BackButton";
import ConfirmButton from "../../components/AppButtons/ConfirmButton";
import FlowConfirmButton from "../../components/AppButtons/FlowConfirmButton";
import FlowBackButton from "../../components/AppButtons/FlowBackButton";
import TextConfirmButton from "../../components/AppButtons/TextConfirmButton";
import TextBackButton from "../../components/AppButtons/TextBackButton";
import { IconTable, TitleDialog } from "./StyleGuide.styles";
import {
  AppIconsActive,
  AppIconsAdd,
  AppIconsAddNote,
  AppIconsApp,
  AppIconsArrow,
  AppIconsBasketSelected,
  AppIconsBrands,
  AppIconsCamera,
  AppIconsCameraHidden,
  AppIconsCancelled,
  AppIconsCart,
  AppIconsCartFilled,
  AppIconsChecklist,
  AppIconsClose,
  AppIconsDate,
  AppIconsDelivery,
  AppIconsDocument,
  AppIconsDocumentChecked,
  AppIconsElaborated,
  AppIconsElaboration,
  AppIconsEmergency,
  AppIconsFlatWeaving,
  AppIconsGears,
  AppIconsHeatSettings,
  AppIconsHourglass,
  AppIconsInfo,
  AppIconsInstallation2,
  AppIconsInstalledBase,
  AppIconsLogoSavio,
  AppIconsLogoVandewiele,
  AppIconsMachineryWinding,
  AppIconsMaintenance,
  AppIconsManufactory,
  AppIconsMenuBurger,
  AppIconsMessage,
  AppIconsOffer,
  AppIconsOfferExpired,
  AppIconsOpen,
  AppIconsOrder,
  AppIconsOrdered,
  AppIconsOrderOffer,
  AppIconsOrderRecived,
  AppIconsOrderShipped,
  AppIconsOrderTypeSell,
  AppIconsOrderTypeService,
  AppIconsPdf,
  AppIconsPower,
  AppIconsPushpin,
  AppIconsQuad,
  AppIconsQuery,
  AppIconsReduce,
  AppIconsRemove,
  AppIconsReorder,
  AppIconsReplaced,
  AppIconsRotorSpinning,
  AppIconsSearch,
  AppIconsSearch2,
  AppIconsShieldFilled,
  AppIconsSubmitted,
  AppIconsUnderCostruction,
  AppIconsUser,
  AppIconsZip,
  AppIconsZoomIn,
  AppIconsZoomOut,
} from "../../components/AppIcons";
import AppIconsArrow1 from "../../components/AppIcons/AppIconsArrow1";
import AppIconsDots from "../../components/AppIcons/AppIconsDots";
import AppIconsHome from "../../components/AppIcons/AppIconsHome";
import AppIconsCartNew from "../../components/AppIcons/AppIconsCartNew";
import AppIconsError from "../../components/AppIcons/AppIconsError";
import AppIconsXls from "../../components/AppIcons/AppIconsXls";
import AppIconsDownload from "../../components/AppIcons/AppIconsDownload";
import CircleButtonBig from "../../components/AppButtons/CircleButtonBig";
import CircleButton from "../../components/AppButtons/CircleButton";
import { StyleguideSavioColors } from "../../configuration/themeSettings";
import { useTranslation } from "../../../explorer/hooks/useTranslation";
import React from "react";

const StyleGuide: React.FC = () => {
  const { t } = useTranslation();

  const [alignment, setAlignment] = React.useState<string | null>("Yes");

  const handleAlignment = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null
  ) => {
    setAlignment(newAlignment);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Typography variant="h4">Icons</Typography>
      <IconTable>
        <li>
          <AppIconsUser />
          <p>AppIconsUser</p>
        </li>
        <li>
          <AppIconsBrands />
          <p>AppIconsBrands</p>
        </li>
        <li>
          <AppIconsOrderOffer />
          <p>AppIconsOrderOffer</p>
        </li>
        <li>
          <AppIconsCart />
          <p>AppIconsCart</p>
        </li>
        <li>
          <AppIconsSearch />
          <p>AppIconsSearch</p>
        </li>{" "}
        <li>
          <AppIconsSearch2 />
          <p>AppIconsSearch2</p>
        </li>
        <li>
          <AppIconsClose />
          <p>AppIconsClose</p>
        </li>
        <li>
          <AppIconsEmergency />
          <p>AppIconsEmergency</p>
        </li>
        <li>
          <AppIconsDocument />
          <p>AppIconsDocument</p>
        </li>
        <li>
          <AppIconsMaintenance />
          <p>AppIconsMaintenance</p>
        </li>
        <li>
          <AppIconsApp />
          <p>AppIconsApp</p>
        </li>
        <li>
          <AppIconsChecklist />
          <p>AppIconsChecklist</p>
        </li>
        <li>
          <AppIconsCameraHidden />
          <p>AppIconsCameraHidden</p>
        </li>
        <li>
          <AppIconsReplaced />
          <p>AppIconsReplaced</p>
        </li>
        <li>
          <AppIconsCamera />
          <p>AppIconsCamera</p>
        </li>{" "}
        <li>
          <AppIconsInstalledBase />
          <p>AppIconsInstalledBase</p>
        </li>
        <li>
          <AppIconsInfo />
          <p>AppIconsInfo</p>
        </li>
        <li>
          <AppIconsElaborated />
          <p>AppIconsElaborated</p>
        </li>
        <li>
          <AppIconsOrderRecived />
          <p>AppIconsOrderRecived</p>
        </li>{" "}
        <li>
          <AppIconsQuery />
          <p>AppIconsQuery</p>
        </li>{" "}
        <li>
          <AppIconsInstallation2 />
          <p>AppIconsInstallation2</p>
        </li>{" "}
        <li>
          <AppIconsDelivery />
          <p>AppIconsDelivery</p>
        </li>
        <li>
          <AppIconsMachineryWinding />
          <p>AppIconsMachineryWinding</p>
        </li>{" "}
        <li>
          <AppIconsBasketSelected />
          <p>AppIconsBasketSelected</p>
        </li>
        <li>
          <AppIconsRotorSpinning />
          <p>AppIconsRotorSpinning</p>
        </li>
        <li>
          <AppIconsFlatWeaving />
          <p>AppIconsFlatWeaving</p>
        </li>
        <li>
          <AppIconsHeatSettings />
          <p>AppIconsHeatSettings</p>
        </li>
        <li>
          <AppIconsShieldFilled />
          <p>AppIconsShieldFilled</p>
        </li>
        <li>
          <AppIconsPower />
          <p>AppIconsPower</p>
        </li>
        <li>
          <AppIconsPdf />
          <p>AppIconsPdf</p>
        </li>
        <li>
          <AppIconsPushpin />
          <p>AppIconsPushpin</p>
        </li>
        <li>
          <AppIconsManufactory />
          <p>AppIconsManufactory</p>
        </li>
        <li>
          <AppIconsOpen />
          <p>AppIconsOpen</p>
        </li>
        <li>
          <AppIconsGears />
          <p>AppIconsGears</p>
        </li>
        <li>
          <AppIconsRemove />
          <p>AppIconsRemove</p>
        </li>
        <li>
          <AppIconsDots />
          <p>AppIconsDots</p>
        </li>
        <li>
          <AppIconsAdd />
          <p>AppIconsAdd</p>
        </li>
        <li>
          <AppIconsLogoVandewiele />
          <p>AppIconsLogoVandewiele</p>
        </li>
        <li>
          <AppIconsLogoSavio />
          <p>AppIconsLogoSavio</p>
        </li>
        <li>
          <AppIconsArrow />
          <p>AppIconsArrow</p>
        </li>
        <li>
          <AppIconsHome />
          <p>AppIconsHome</p>
        </li>
        <li>
          <AppIconsReduce />
          <p>AppIconsReduce</p>
        </li>
        <li>
          <AppIconsZoomIn />
          <p>AppIconsZoomIn</p>
        </li>
        <li>
          <AppIconsZoomOut />
          <p>AppIconsZoomOut</p>
        </li>
        <li>
          <AppIconsQuad />
          <p>AppIconsQuad</p>
        </li>
        <li>
          <AppIconsCartNew />
          <p>AppIconsCartNew</p>
        </li>
        <li>
          <AppIconsDownload />
          <p>AppIconsDownload</p>
        </li>
        <li>
          <AppIconsError />
          <p>AppIconsError</p>
        </li>
        <li>
          <AppIconsXls />
          <p>AppIconsXls</p>
        </li>
        <li>
          <AppIconsCartFilled />
          <p>AppIconsCartFilled</p>
        </li>
        <li>
          <AppIconsUnderCostruction />
          <p>AppIconsUnderCostruction</p>
        </li>
        <li>
          <AppIconsSubmitted />
          <p>AppIconsSubmitted</p>
        </li>
        <li>
          <AppIconsReorder />
          <p>AppIconsReorder</p>
        </li>
        <li>
          <AppIconsOrderShipped />
          <p>AppIconsOrderShipped</p>
        </li>
        <li>
          <AppIconsOrderTypeService />
          <p>AppIconsOrderTypeService</p>
        </li>
        <li>
          <AppIconsOrder />
          <p> AppIconsOrder</p>
        </li>
        <li>
          <AppIconsOffer />
          <p> AppIconsOffer</p>
        </li>
        <li>
          <AppIconsOrdered />
          <p>AppIconsOrdered</p>
        </li>
        <li>
          <AppIconsOfferExpired />
          <p>AppIconsOfferExpired</p>
        </li>
        <li>
          <AppIconsMessage />
          <p>AppIconsMessage</p>
        </li>
        <li>
          <AppIconsHourglass />
          <p>AppIconsHourglass</p>
        </li>
        <li>
          <AppIconsElaboration />
          <p>AppIconsElaboration</p>
        </li>
        <li>
          <AppIconsCancelled />
          <p>AppIconsCancelled</p>
        </li>
        <li>
          <AppIconsDate />
          <p>AppIconsDate</p>
        </li> 
        <li>
          <AppIconsActive />
          <p>AppIconsActive</p>
        </li> 
        <li>
          <AppIconsAddNote />
          <p>AppIconsAddNote</p>
        </li> 
        <li>
          <AppIconsMenuBurger />
          <p>AppIconsMenuBurger</p>
        </li>  
        <li>
          <AppIconsZip />
          <p>AppIconsZip</p>
        </li>  
        <li>
          <AppIconsDocumentChecked />
          <p>AppIconsDocumentChecked</p>
        </li>   <li>
          <AppIconsOrderTypeSell />
          <p>AppIconsOrderTypeSell</p>
        </li>  
      </IconTable>

      <Typography variant="h4">Buttons (stili)</Typography>

      <table style={{ margin: "20px auto" }}>
        <thead>
          <tr>
            <th></th>
            <th>size=small</th>
            <th>size=medium</th>
            <th>size=large</th>
            <th>color=secondary</th>
            <th>color=primary disabled</th>
            <th>color=secondary disabled</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>variant=contained</th>
            <td>
              <Button variant="contained" size="small">
                Button
              </Button>
            </td>
            <td>
              <Button variant="contained" size="medium">
                Button
              </Button>
            </td>
            <td>
              <Button variant="contained" size="large">
                Button
              </Button>
            </td>
            <td>
              <Button variant="contained" size="large" color="secondary">
                Button
              </Button>
            </td>
            <td>
              <Button variant="contained" size="large" disabled>
                Button
              </Button>
            </td>
            <td>
              <Button
                variant="contained"
                size="large"
                color="secondary"
                disabled
              >
                Button
              </Button>
            </td>
          </tr>
          <tr>
            <th>variant=text</th>
            <td>
              <Button variant="text" size="small">
                Button
              </Button>
            </td>
            <td>
              <Button variant="text" size="medium">
                Button
              </Button>
            </td>
            <td>
              <Button variant="text" size="large">
                Button
              </Button>
            </td>
            <td>
              <Button variant="text" size="large" color="secondary">
                Button
              </Button>
            </td>
            <td>
              <Button variant="text" size="large" disabled>
                Button
              </Button>
            </td>
            <td>
              <Button variant="text" size="large" color="secondary" disabled>
                Button
              </Button>
            </td>
          </tr>
          <tr>
            <th>variant=outlined</th>
            <td>
              <Button variant="outlined" size="small">
                Button
              </Button>
            </td>
            <td>
              <Button variant="outlined" size="medium">
                Button
              </Button>
            </td>
            <td>
              <Button variant="outlined" size="large">
                Button
              </Button>
            </td>
            <td>
              <Button variant="outlined" size="large" color="secondary">
                Button
              </Button>
            </td>
            <td>
              <Button variant="outlined" size="large" disabled>
                Button
              </Button>
            </td>
            <td>
              <Button
                variant="outlined"
                size="large"
                color="secondary"
                disabled
              >
                Button
              </Button>
            </td>
          </tr>
        </tbody>
      </table>

      <Typography variant="h4">Buttons (componenti)</Typography>
      <Grid container spacing={2}>
        <Grid item xs={2}>
          <Box>
            <ConfirmButton>ConfirmButton</ConfirmButton>
            <br />
            {"<ConfirmButton>"}
          </Box>
        </Grid>

        <Grid item xs={2}>
          <Box>
            <BackButton>BackButton</BackButton>
            <br />
            {"<BackButton>"}
          </Box>
        </Grid>

        <Grid item xs={2} position="relative">
          <Box>
            <FlowConfirmButton>FlowConfirmButton</FlowConfirmButton>
            <br />
            {"<FlowConfirmButton>"}
          </Box>
        </Grid>

        <Grid item xs={2}>
          <Box>
            <FlowBackButton>FlowBackButton</FlowBackButton>
            <br />
            {"<FlowBackButton>"}
          </Box>
        </Grid>

        <Grid item xs={2} position="relative">
          <Box>
            <TextConfirmButton>TextConfirmButton</TextConfirmButton>
            <br />
            {"<TextConfirmButton>"}
          </Box>
        </Grid>

        <Grid item xs={2}>
          <Box>
            <TextBackButton>TextBackButton</TextBackButton>
            <br />
            {"<TextBackButton>"}
          </Box>
        </Grid>

        <Grid item xs={2}>
          <Box>
            <CircleButtonBig>
              <AppIconsArrow1 />
            </CircleButtonBig>
            <br />
            {"<CircleButtonBig>"}
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Box>
            <CircleButton>
              <AppIconsArrow1 />
            </CircleButton>
            <br />
            {"<CircleButton>"}
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Box>
            <CircleButton className="negative">
              <AppIconsArrow1 />
            </CircleButton>
            <br />
            {"<CircleButton>"}
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Box>
            <ToggleButtonGroup
              exclusive
              value={alignment}
              aria-label="Yes No toggle"
              onChange={handleAlignment}
              size="small"
            >
              <ToggleButton value="Yes">Yes</ToggleButton>
              <ToggleButton value="No">No</ToggleButton>
              <ToggleButton value="Disabled" disabled>
                Disabled
              </ToggleButton>
            </ToggleButtonGroup>
            <br />
            {"<ToggleButtonGroup>"}
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Box>
            <ToggleButtonGroup
              exclusive
              value={alignment}
              aria-label="Yes No toggle"
              onChange={handleAlignment}
              size="medium"
            >
              <ToggleButton value="Yes">Yes</ToggleButton>
              <ToggleButton value="No">No</ToggleButton>
              <ToggleButton value="forse">forse</ToggleButton>
              <ToggleButton value="Disabled" disabled>
                Disabled
              </ToggleButton>
            </ToggleButtonGroup>
            <br />
            {"<ToggleButtonGroup>"}
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Box>
            <ToggleButtonGroup
              exclusive
              value={alignment}
              aria-label="Yes No toggle"
              onChange={handleAlignment}
              size="large"
              color="secondary"
            >
              <ToggleButton value="Yes">Yes</ToggleButton>
              <ToggleButton value="No">No</ToggleButton>
             
              <ToggleButton value="Disabled" disabled>
                Disabled
              </ToggleButton>
            </ToggleButtonGroup>
            <br />
            {"<ToggleButtonGroup>"}
          </Box>
        </Grid>
      </Grid>

      <Alert
        sx={{ mb: 2, mt: 2 }}
        severity="info"
        onClose={() => {}}
        icon={false}
      >
        <TitleDialog>{t("alert.title.information")}</TitleDialog>
        This Alert displays the default close icon.
      </Alert>

      <Alert
        sx={{ mb: 2, mt: 2 }}
        severity="success"
        onClose={() => {}}
        icon={false}
      >
        <TitleDialog>{t("alert.title.success")}</TitleDialog>
        This Alert displays the default close icon.
      </Alert>

      <Alert
        sx={{ mb: 2, mt: 2 }}
        severity="error"
        onClose={() => {}}
        icon={false}
      >
        <TitleDialog>{t("alert.title.error")}</TitleDialog>
        This Alert displays the default close icon.
      </Alert>

      <Alert
        sx={{ mb: 2, mt: 2 }}
        severity="warning"
        onClose={() => {}}
        icon={false}
      >
        <TitleDialog>{t("alert.title.warning")}</TitleDialog>
        This Alert displays the default close icon.
      </Alert>
    </Box>
  );
};
export default StyleGuide;
